<template>
    <div class="task-list">

        <h3 class="task-list__title">{{ __('My tasks') }}</h3>
        <div class="task-list__new-task is-relative" v-if="showActions">
            <input autofocus autocomplete="off"
                   v-bind:class="{'has-error': errors.task}"
                   v-bind:placeholder="__('What needs to be done?')"
                   v-model="newTask"
                   v-on:keyup.enter="addTask" />
            <button class="btn task-list__new-task__btn is-primary is-small" v-on:click="addTask">{{ __('Add') }}</button>
            <span class="error--text has-margin-t5 is-block" v-html="errors.task" v-if="errors.task"></span>
        </div>

        <div class="task-list__content" v-show="tasks.length" v-cloak>
            <ul class="task-list__list">
                <li class="task"
                    v-bind:key="task.id"
                    v-bind:class="{ 'task--completed': task.completed, 'task--editing': task == editedTask }"
                    v-for="task in filteredTasks">
                    <div class="task__view">
                        <input class="toggle" type="checkbox" v-model="task.completed" v-on:click="changeStatus(task)">
                        <label v-on:dblclick="editTask(task)">{{ task.title }}</label>
                        <button class="task__view__destroy jam jam-close" v-if="showActions" v-on:click="removeTask(task)"></button>
                        <button class="task__view__edit jam jam-pencil" v-if="showActions" v-on:click="editTask(task)"></button>
                    </div>
                    <input class="task__edit" type="text"
                           v-model="task.title"
                           v-on:blur="doneEdit(task)"
                           v-on:keyup.enter="doneEdit(task)"
                           v-on:keyup.esc="cancelEdit(task)"
                           v-task-focus="task == editedTask"/>
                </li>
            </ul>
        </div>
        <div class="task-list__footer" v-if="showActions" v-show="tasks.length" v-cloak>
            <span class="task-list__footer__count">
              <strong>{{ remaining }}</strong> {{ remaining | pluralize }} left
            </span>
            <ul class="filters">
                <li><a v-bind:class="{ selected: visibility == 'all' }" v-on:click="changeFilter('all')">{{ __('All') }}</a></li>
                <li><a v-bind:class="{ selected: visibility == 'active' }" v-on:click="changeFilter('active')">{{ __('Active') }}</a></li>
                <li><a v-bind:class="{ selected: visibility == 'completed' }" v-on:click="changeFilter('completed')">{{ __('Completed') }}</a></li>
            </ul>
            <button class="clear-completed" v-on:click="removeCompleted" v-show="tasks.length > remaining">
                {{ __('Clear completed') }}
            </button>
        </div>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    // visibility filters
    var filters = {
        all: function (tasks) {
            return tasks;
        },
        active: function (tasks) {
            return tasks.filter(function (task) {
                return !task.completed;
            })
        },
        completed: function (tasks) {
            return tasks.filter(function (task) {
                return task.completed;
            })
        }
    };

    export default {
        computed: {
            filteredTasks: function () {
                return filters[this.visibility](this.tasks);
            },
            remaining: function () {
                return filters.active(this.tasks).length;
            },
            allDone: {
                get: function () {
                    return this.remaining === 0;
                },
                set: function (value) {
                    this.tasks.forEach(function (task) {
                        task.completed = value;
                    })
                }
            }
        },
        data: function () {
            return {
                editedTask: null,
                errors: {
                    task: ''
                },
                newTask: '',
                tasks: [],
                visibility: 'all'
            }
        },
        directives: {
            'task-focus': function (el, binding) {
                if (binding.value) {
                    el.focus();
                }
            }
        },
        filters: {
            pluralize: function (n) {
                return n === 1 ? 'item' : 'items'
            }
        },
        methods: {
            addTask: function () {
                var value = this.newTask && this.newTask.trim();

                this.errors.task = '';
                if (!value) {
                    this.errors.task = this.__('Required field');
                    return;
                }

                eventBus.$emit('show-loader');

                let data = {
                    'title': value,
                    'user_id': this.user.id
                };

                this.$http.post(this.apiUrl + '/tasks', data).then(function (response) {
                    let task = response.body;
                    this.tasks.push({
                        id: task.id,
                        title: task.title,
                        completed: !!task.completed
                    });

                    eventBus.$emit('hide-loader');
                    eventBus.$emit('show-alert', 'success', this.__('Task has been successfully saved.'));
                }.bind(this), function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );
                }.bind(this));

                this.newTask = '';
            },
            cancelEdit: function (task) {
                this.editedTask = null;
                task.title = this.beforeEditCache;
            },
            changeFilter: function (visibility) {
                this.visibility = visibility;
            },
            changeStatus: function (task) {
                task.completed = !task.completed;

                let data = {
                    'completed': task.completed
                };

                this.$http.patch(this.apiUrl + '/tasks/' + task.id, data).then(function (response) {
                    eventBus.$emit('show-alert', 'success', this.__('Task has been successfully saved.'));
                });
            },
            doneEdit: function (task) {
                if (!this.editedTask) {
                    return
                }
                this.editedTask = null;
                task.title = task.title.trim();

                if (!task.title) {
                    this.removeTask(task);
                    return;
                }

                let data = {
                    'title': task.title
                };

                this.$http.patch(this.apiUrl + '/tasks/' + task.id, data).then(function (response) {
                    eventBus.$emit('hide-loader');
                    eventBus.$emit('show-alert', 'success', this.__('Task has been successfully saved.'));
                }.bind(this), function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );
                }.bind(this));
            },
            getTasks: function () {
                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/tasks', {
                    params : {
                        filters: {
                            'user_id': this.user.id
                        },
                        page: 1,
                        perPage: 0
                    }
                }).then(function (response) {
                    this.tasks = response.body.original.data;

                    eventBus.$emit('hide-loader');
                }.bind(this), function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            editTask: function (task) {
                if (this.showActions) {
                    this.beforeEditCache = task.title;
                    this.editedTask = task;
                }
            },
            init: function () {
                this.getTasks();
            },
            removeCompleted: function () {
                this.tasks = filters.active(this.tasks);
            },
            removeTask: function (task) {
                this.tasks.splice(this.tasks.indexOf(task), 1);

                this.$http.delete(this.apiUrl + '/tasks/' + task.id).then(function (response) {
                    eventBus.$emit('hide-loader');
                    eventBus.$emit('show-alert', 'success', this.__('Task has been successfully removed.'));
                }.bind(this), function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit('hide-loader');

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );
                }.bind(this));
            }
        },
        mounted: function () {
            this.init();
        },
        props: {
            showActions: {
                default: true,
                type: Boolean
            }
        }

    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/TaskList.vue